import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface ImportItemsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Dialog for importing shopping items.
 * Keeps the UI minimal to avoid overwhelming users.
 */
const ImportItemsDialog = ({ open, onOpenChange }: ImportItemsDialogProps) => {
  const { theme } = useThemeConfig();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="min-h-[40vh]"
        containerClassName="h-full overflow-y-auto"
        style={{
          borderRadius: theme.borderRadius || '0.5rem',
          backgroundColor: theme.backgroundColor || '#ffffff',
          color: theme.textColor || '#000000',
        }}
      >
        <DialogHeader>
          <DialogTitle>Importa elementi</DialogTitle>
          <DialogDescription>
            Carica articoli da file o appunti.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4">
          <Button
            onClick={() => onOpenChange(false)}
            className="ml-auto"
            style={{
              borderRadius: theme.buttonBorderRadius || '0.375rem',
              padding: theme.buttonPadding,
            }}
            aria-label="Chiudi"
          >
            Chiudi
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ImportItemsDialog;
